import useAjaxRequest from './useAjaxRequest';
import { URL_MARITAL_STATES } from '../config/endpoints';

const options = {
  method: 'get',
  url: URL_MARITAL_STATES(),
};
const cacheConfig = {
  shouldCache: true,
  isCacheValid: () => true,
};
const useMaritalStates = () => {
  const {
    response: { error, loading, data: maritalStates },
  } = useAjaxRequest('maritalState', cacheConfig, options, []);

  return { error, loading, maritalStates };
};

export default useMaritalStates;
